
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

/*********** COMPONENT IMPORTS *************/
import Navbar from "./layouts/Navbar";
import Newnavbar from "./pages/modules/Newnavbar";
import Cloud from "./pages/modules/Cloudkitchen/Cloud";
import Telecast from "./pages/Telecast";
import Home from "./pages/Home";

// Main Components
import Mainsidebar from "./layouts/Mainsidebar";

// Vendor / User Pages
import Maamaasuser from "./pages/modules/Component/Maamaasuser";
import CateringHomemaamaas from "./pages/modules/Component/Catering/CateringHomemaamaas";


// Menus
import Newmenuiteam from "./pages/modules/Component/Newmenuiteam";
import CateringMenu from "./pages/modules/Component/Catering/CateringMenu";

import TableMenu from "./pages/modules/Component/TableMenu";

// Carts
import Cartsdata from "./pages/modules/Component/Cartsdata";
import CateringsCartdata from "./pages/modules/Component/Catering/CateringsCartdata";

import TableCart from "./pages/modules/Component/TableCart";

// Other Components
import Catreningitem from "./pages/modules/Component/Catreningitem";
import Coustmizemenu from "./pages/modules/Component/Coustmizemenu";
import Categringcart from "./pages/modules/Component/Categringcart";
import Digitalfoodall from "./pages/modules/Component/Digitalfood/Digitalfoodall";
import Forgetpassword from "./pages/modules/Component/Forgetpassword";
import Catreingpakagecartpage from "./pages/modules/Component/Catreingpakagecartpage";
import Topcatringresturent from "./pages/modules/Component/Topcatringresturent";
import Termscondition from "./pages/modules/Component/Termscondition";
import Policy from "./pages/Policy";
import Maamaasacount from "./pages/modules/Component/Maamaasacount";


import Allorderaccepts from "./pages/modules/Component/Allorderaccepts";
import Profilepage from "./pages/modules/Component/Profile/Profilepage";

import Profesanlprofile from './pages/modules/Component/Profile/Profesanlprofile';
import Tablebooking from "./pages/modules/Component/Tablebooking";
import Saprateoffers from './pages/modules/Component/Saprateoffers';
import ProfissionalNavbar from "./layouts/ProfissionalNavbar";
import ProfessionalRegistration from "./pages/ProfessionalRegistration.jsx";

// Loader
import { LoaderProvider } from "./pages/modules/Component/Context/LoaderProvider.jsx";
import AnalyticsTracker from './pages/AnalyticsTracker.js';

import Cateringpage from './pages/modules/Cloudkitchen/Cateringpage.jsx';
import Diliverypolicy from "./pages/modules/Component/Diliverypolicy.jsx";
import Orderstates from "./pages/modules/Component/Orderstates.jsx";

import Userdashbord from "./pages/sidebarcall/Userdashbord.jsx";
import Newnearbyresturent from "./pages/sidebarcall/Newnearbyresturent.jsx";
import Newprofile from "./pages/sidebarcall/Newprofile.jsx";
import SettingsPremium from "./pages/sidebarcall/SettingsPremium.jsx";
import Myorder from "./pages/sidebarcall/Myorder.jsx";
import Favnew from "./pages/sidebarcall/Favnew.jsx";
import Newsuport from "./pages/sidebarcall/Newsuport.jsx";
import Reportsanlysics from "./pages/sidebarcall/Reportsanlysics.jsx";
import Walletsidebar from "./pages/sidebarcall/Walletsidebar"

import Notifications from './pages/modules/Component/Profile/Notifications.js'

import Tablemainfile from './Tablemenu/Tablemainfile.jsx'
import Myordermain from './pages/sidebarcall/Myordermain'

import Vendorbanner from './Tablemenu/Vendorbanner.jsx'

import MenuitemsTablemain from './Dineoutmenu/MenuitemsTablemain.jsx'
import Acountseetings from "./pages/sidebarcall/Acountseeting.jsx";
import Adressnew from "./pages/sidebarcall/Adressnew.jsx";
import ReferEarn from "./pages/modules/Component/Profile/ReferEarn.js";
import Usertable from './Dineoutmenu/Usertable.jsx'
import Spinwin from './pages/Spinwin';
import RefundPolicy from './pages/RefundPolicy.jsx'

import ReturnPolicy from './pages/ReturnPolicy'
import ShippingPolicy from './pages/ShippingPolicy';
import Download from './pages/Download.jsx';

/************** LAYOUT **************/
function Layout({ showLogin, setShowLogin, isSignup, setIsSignup, isLoggedIn }) {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");

  // Pages jaha purana Navbar dikhna chahiye
  const showNavbarRoutes = [
    "/",
    "/telecast",
    "/Cloud",
    "/donations",
    "/news",
    "/events",
    "/bookings",
  ];

  // Pages jaha New Navbar dikhna chahiye
  const showNewNavbarRoutes = [
    "/Maamaasuser",
    "/cateringHomemaamaas",
    "/groceryvendorstore",
    "/groceryMain",
    "/Newmenuiteam",
   
    "/groceryMenu",
    "/tablemenu",
    "/tablebooking",
    "/cartsdata",
    "/cateringscartdata",
    "/grocerycart",
    "/tablecart",
    "/profilepage",
    "/Catreningitem",
    "/Coustmizemenu",
    "/Digitalfoodall",
    "/Categringcart",
    "/Catreingpakagecartpage",
    "/Topcatringresturent",
    "/Termscondition",
   
    "/Activegroccery",
    "/Activelogostics",
    "/allorderaccepts",
    "/Saprateoffers",
    "/Cateringpage",
    "/order-status",
    "/user-dashboard",
    "/Newnearbyresturent",
    "/Newprofile",
    "/Favnew",
    "/Reportsanlysics",
    "/Acountseeting",
    "/Adressnew",
    "/ReferEarn",
  ];

  // Exact routes for sidebar (no parameters)
  const sidebarExactRoutes = [
    "/user-dashboard",
    "/Digitalfoodall",
    "/Newnearbyresturent",
    "/Newprofile",
    "/SettingsPremium",
    "/Myorder",
    "/Favnew",
    "/Newsuport",
    "/Reportsanlysics",
    "/Layoutcall",
  ];

  // Routes with dynamic parameters that should show sidebar
  const sidebarPatternRoutes = [
    "/Newmenuiteam",
    "/allorderaccepts",
    "/order-status",
    "/Saprateoffers",
    "/Maamaasuser",
    "/cateringHomemaamaas",
    "/groceryvendorstore",
    "/Walletsidebar",
    "/Notifications",
    "/tablemenu",
    "/Tablemainfile",
    "/Myordermain",
    "/Vendorbanner",
    "/cateringmenu",
    "/MenuitemsTablemain",
    "/Acountseetings", 
    "/Adressnew",
    "/ReferEarn", 
    "/Usertable",
    "/Spinwin",
   
  ];
  
  // Check if navbar should be shown
  const showNavbar = showNavbarRoutes.includes(location.pathname);
  
  // Check if new navbar should be shown (using startsWith for dynamic routes)
  const showNewNavbar = showNewNavbarRoutes.some(route => 
    location.pathname.startsWith(route)
  );
  
  // Check if sidebar should be shown (using startsWith for dynamic routes)
  const showSidebar = () => {
    // Check exact matches
    if (sidebarExactRoutes.includes(location.pathname)) {
      return true;
    }
    
    // Check pattern matches (routes with dynamic parameters)
    return sidebarPatternRoutes.some(route => 
      location.pathname.startsWith(route)
    );
  };

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {showNavbar && <Navbar showLogin={showLogin} setShowLogin={setShowLogin} />}
      {showNewNavbar && <Newnavbar showLogin={showLogin} setShowLogin={setShowLogin} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />}

      <div style={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
        {showSidebar() && (
          <div style={{ flexShrink: 0 }}>
            <Mainsidebar />
          </div>
        )}
        <div style={{ flexGrow: 1, overflow: "auto",scrollbarWidth:'none' }}>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={
              <Cloud
                setShowLogin={setShowLogin}
                setIsSignup={setIsSignup}
                isLoggedIn={isLoggedIn}
              />
            } />
            <Route path="/telecast" element={<Telecast />} />

            <Route path="/Maamaasuser/:vendorId" element={<Maamaasuser />} />
            <Route path="/cateringHomemaamaas/:vendorId" element={<CateringHomemaamaas />} />
       

            <Route path="/Newmenuiteam/:vendorId" element={<Newmenuiteam setShowLogin={setShowLogin} />} />
            <Route path="/cateringmenu/:vendorId" element={<CateringMenu setShowLogin={setShowLogin} />} />
           
            <Route path="/Catreningitem" element={<Catreningitem setShowLogin={setShowLogin} />} />

            <Route path="/tablemenu/:vendorId" element={<TableMenu setShowLogin={setShowLogin} />} />
            <Route path="/tableBooking" element={<Tablebooking />} />
            <Route path="/tablecart" element={<TableCart />} />
            <Route path="/cartsdata" element={<Cartsdata />} />
            <Route path="/cateringscartdata" element={<CateringsCartdata />} />
           

            <Route path="/Digitalfoodall" element={<Digitalfoodall />} />
            <Route path="/Coustmizemenu" element={<Coustmizemenu />} />
            <Route path="/Categringcart" element={<Categringcart />} />
            <Route path="/Catreingpakagecartpage" element={<Catreingpakagecartpage />} />
            <Route path="/Topcatringresturent" element={<Topcatringresturent />} />
            <Route path="/Forgetpassword" element={<Forgetpassword />} />

            <Route path="/Termscondition" element={<Termscondition />} />
            <Route path="/privacy-policys" element={<Policy />} />
            <Route path="/maamaas-deletion" element={<Maamaasacount />} />

           
           
            <Route path="/allorderaccepts/:vendorId" element={<Allorderaccepts />} />
            <Route path="/Saprateoffers/:vendorId" element={<Saprateoffers />} />
            <Route path="/Cateringpage" element={<Cateringpage />} />
            <Route path="/movers-policy" element={<Diliverypolicy />} />
            <Route path="/order-status/:orderId/:vendorId?" element={<Orderstates />} />

            <Route path="/profilepage" element={<Profilepage />} />

            <Route path="/user-dashboard" element={<Userdashbord />} />
            <Route path="/Newnearbyresturent" element={<Newnearbyresturent />} />
            <Route path="/Newprofile" element={<Newprofile />} />
            <Route path="/SettingsPremium" element={<SettingsPremium />} />
            <Route path="/Myorder" element={<Myorder />} />
            <Route path="/Favnew" element={<Favnew />} />
            <Route path="/Newsuport" element={<Newsuport />} />
            <Route path="/Reportsanlysics" element={<Reportsanlysics />} />
             <Route path="/Walletsidebar" element={<Walletsidebar />} />
             <Route path="/Notifications" element={<Notifications />} />
              <Route path="/Tablemainfile/:vendorId" element={<Tablemainfile />} />
               <Route path="/Myordermain" element={<Myordermain />} />
                <Route path="/Vendorbanner" element={<Vendorbanner />} />
                <Route path="/MenuitemsTablemain/:vendorId" element={<MenuitemsTablemain />} />
                  <Route path="/Acountseetings" element={<Acountseetings />} />
                    <Route path="/Adressnew" element={<Adressnew />} />
                      <Route path="/ReferEarn" element={<ReferEarn />} />
                       <Route path="/Usertable" element={<Usertable />} />
                       <Route path="/Spinwin"element={<Spinwin/>}/>
                        <Route path="/refundPolicy"element={< RefundPolicy/>}/>
                         <Route path="/returnPolicy"element={<ReturnPolicy/>}/>
                           <Route path="/shippingPolicy"element={<ShippingPolicy/>}/>
                             <Route path="/app-url"element={<Download/>}/>
                        

                      
                     
        
                


              
              

             

             

            

            {/* fallback */}
            <Route path="*" element={<Cloud setShowLogin={setShowLogin} setIsSignup={setIsSignup} isLoggedIn={isLoggedIn} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function ProfessionalLayout() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <ProfissionalNavbar />

      <div style={{ flexGrow: 1 }}>
        <Routes>
          <Route
            path="/professional-registration"
            element={<ProfessionalRegistration />}
          />
          <Route
            path="/Profesanlprofile"
            element={<Profesanlprofile />}
          />

          {/* fallback */}
          <Route
            path="*"
            element={<ProfessionalRegistration />}
          />
        </Routes>
      </div>
    </div>
  );
}

/************** MAIN APP **************/
export default function App() {
  const [showLogin, setShowLogin] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const professionalUserId = localStorage.getItem("professionalUserId");
  const isLoggedInFromStorage = localStorage.getItem("isLoggedIn") === "true";

  // Check if user is professional
  const isProfessionalUser =
    isLoggedInFromStorage && Boolean(professionalUserId);

  return (
    <LoaderProvider>
      <Router>
        {isProfessionalUser ? (
          <ProfessionalLayout />
        ) : (
          <Layout
            showLogin={showLogin}
            setShowLogin={setShowLogin}
            isSignup={isSignup}
            setIsSignup={setIsSignup}
            isLoggedIn={isLoggedIn}
          />
        )}
      </Router>
    </LoaderProvider>
  );
}
